<template>
    <div>
        <div class="mb-3 sbalerts" v-if="alerts.length>0">
            <div class="notification ml-4 mt-0 mb-2">
                <i class="fas fa-bell fa-2x"></i><span class="badge">{{alert_count}}</span>
            </div>
            <span class="ml-3 sb-notification-span font-weight-bold sb-block-title">You have unread notifications</span>
            <div v-for="(sbalert, index) in alerts" :class="'opportunity-bullet alert alert-'+getPriority(sbalert.priority)+' mb-2 mr-3 ml-3'+(sbalert.read_at==null?'':' d-none')" role="alert">
                <i class="fas fa-exclamation-circle mr-2"></i>{{sbalert.subject}}
                <br/>
                <!-- Button trigger modal -->
                <a class="learn-more-lnk" href="#" data-toggle="modal" @click="readAlert(index,sbalert)" data-target="#alertModal">Learn More</a>
            </div>
        </div>

        <div v-else class="mb-3 sbalerts nosbalerts text-center">
            <div class="alert">There are no new notifications available at this time</div>
        </div>

        <div class="mb-3 sbalerts sbalerts_read pt-3" v-if="showunread=='true' && alertsread.length>0">
            <div class="mb-2"><span class="ml-3 sb-notification-span font-weight-bold sb-block-title">Read notifications</span></div>
            <div v-for="(sbalert, index) in alertsread" :class="'opportunity-bullet alert alert-'+getPriority(sbalert.priority)+' mb-2 mr-3 ml-3'" role="alert">
                <i class="fas fa-exclamation-circle mr-2"></i>{{sbalert.subject}}
                <button type="button" class="btn btn-danger float-right" data-dismiss="alert" aria-label="Close" @click="deleteAlert(index,sbalert)">
                    Delete
                </button>
                <br/>
                <!-- Button trigger modal -->
                <a class="learn-more-lnk" href="#" data-toggle="modal" @click="readAlert(index,sbalert)" data-target="#alertModal">Learn More</a>
            </div>
        </div>

        <!-- Modal -->

        <div class="modal fade" id="alertModal" tabindex="-1" role="dialog" aria-labelledby="alertModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="alertModalLabel">{{sbalert.subject}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body"><b>Received:</b> {{formatDate(sbalert.created_at)}}</div>
                    <div class="modal-body" v-html="sbalert.message">
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            alerts: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            showunread: {},
            alertsread: {
                type: Array,
                default: function () {
                    return [];
                }
            }
        },
        mounted() {
            this.alert_count=this.alerts.length
        },
        data(){
            return {
                route: '/api/alert-read',
                alert_count:0,
                sbalert:{
                    subject:'',
                    message:'',
                    created_at: ''
                }
            }
        },
        methods: {
            readAlert(key,value) {
                this.sbalert = value
                if(value.read_at==null){
                    this.$http.post(this.route, this.sbalert)
                        .then(function(response) {
                            this.$notify({
                                type:'success',
                                title: 'Success',
                                text: 'Alert was marked as read!'
                            });
                            $('#alert_count').html($('#alert_count').html()==0?0:$('#alert_count').html()-1);
                            this.alert_count--;
                            this.alerts.splice(key,1)
                            value.read_at = new Date()
                            this.alertsread.push(value)
                        }, (response) => {

                        })

                }
            },
            deleteAlert(key,value){
                this.sbalert=value
                this.$http.post(this.route+'/delete', this.sbalert)
                    .then(function(response) {
                        this.$notify({
                            type:'success',
                            title: 'Success',
                            text: 'Alert was deleted!'
                        });
                        this.alertsread.splice(key,1)
                    }, (response) => {

                    })
            },
            getTimeStamp(){
                var currentdate = new Date();
                return currentdate.getDate() + "/"
                    + (currentdate.getMonth()+1)  + "/"
                    + currentdate.getFullYear() + " @ "
                    + currentdate.getHours() + ":"
                    + currentdate.getMinutes() + ":"
                    + currentdate.getSeconds();
            },
            getPriority(priority){
                switch(priority) {
                    case 'low':
                        return 'success'
                        break;
                    case 'medium':
                        return 'warning';
                        break;
                    case 'high':
                        return 'danger';
                        break;
                    default:
                        return 'success';
                }
            },
            formatDate(dateString) {
                const date = new Date(dateString);
                if (isNaN(date.getTime())) return dateString;
                const hours = date.getHours();
                const minutes = date.getMinutes();
                const seconds = date.getSeconds();
                const ampm = hours >= 12 ? ' PM' : ' AM';
                const formattedHours = hours % 12 || 12;
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const day = date.getDate().toString().padStart(2, '0');
                const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
                const formattedSeconds = seconds < 10 ? '0' + seconds : seconds;
                return `${month}/${day}/${date.getFullYear()} ${formattedHours}:${formattedMinutes}:${formattedSeconds}${ampm}`;
            }
        }
    }
</script>
